export default "__VITE_ASSET__z38p8zeK__"